import { useState } from 'react'
import { Building2, Lock, ArrowRight } from 'lucide-react'

export default function Login({ onLogin }: { onLogin: () => void }) {
  const [code, setCode] = useState('')
  const [error, setError] = useState('')

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (code.trim().length > 0) {
      onLogin()
    } else {
      setError('Введите код доступа')
    }
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ width: 64, height: 64, borderRadius: 'var(--radius-xl)', background: 'linear-gradient(135deg, var(--accent-dim), var(--accent))', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px', boxShadow: '0 8px 32px var(--accent-glow)' }}>
            <Building2 size={28} color="white" />
          </div>
          <h1 style={{ fontSize: 24, fontWeight: 700, color: 'var(--text-primary)', marginBottom: 8 }}>Checko Control</h1>
          <p style={{ fontSize: 14, color: 'var(--text-muted)' }}>Войдите в панель управления сбором данных</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Код доступа</label>
            <div style={{ position: 'relative' }}>
              <Lock size={16} style={{ position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)', color: 'var(--text-muted)' }} />
              <input className="input" type="password" placeholder="Введите код" value={code} onChange={e => { setCode(e.target.value); setError('') }} style={{ paddingLeft: 40 }} autoFocus />
            </div>
            {error && <div style={{ color: 'var(--danger)', fontSize: 13, marginTop: 6 }}>{error}</div>}
          </div>

          <button className="btn btn-primary btn-lg" style={{ width: '100%', marginTop: 8 }} type="submit">
            Войти <ArrowRight size={16} />
          </button>
        </form>

        <div style={{ marginTop: 24, textAlign: 'center', fontSize: 12, color: 'var(--text-muted)' }}>
          Любой код доступа принят для демонстрации
        </div>
      </div>
    </div>
  )
}
